var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tableComponent,{key:_vm.item.entity.key,tag:"component",staticClass:"flex-grow-1 mt-3",attrs:{"entity-key":_vm.item.entity.key,"fixed-values":_vm.getFixedValues(_vm.item)}})
}
var staticRenderFns = []

export { render, staticRenderFns }